export default __webpack_public_path__ + "static/media/stargaragen_2.d936ba2d.jpg";